import React from "react";

/**
 * Thin red-white ribbon evoking the Peruvian flag (Rojo Bicentenario + white).
 * Used as delicate divider element in header, footer and section separators.
 */
export default function PeruRibbon({ className = "", height = 4 }) {
  return (
    <div
      className={className}
      style={{ height, width: "100%" }}
      aria-hidden="true"
      role="presentation"
    >
      <div style={{ height: "100%", display: "flex" }}>
        <div style={{ flex: 1, background: "#C8102E" }} />
        <div style={{ flex: 1, background: "#F7F7F5" }} />
        <div style={{ flex: 1, background: "#C8102E" }} />
      </div>
    </div>
  );
}
